import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import style from "./style.module.css";
import { WEBSITE_NAME } from '../../modals/Constants';
import { getStorage } from '../../modals/Storage';
import Button from '../../UI/Button/ui';

function View({ screen }) {
    const [menuSlider, setMenuSlider] = useState(false);
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        const stored = getStorage("categories");
        if (stored) {
            setCategories(JSON.parse(stored));
        }
    }, []);

    return (
        <div className={style.parentView}>
            <div className={style.headerView}>
                {screen !== "login" ?
                    <button className={style.menuBtn} onClick={() => setMenuSlider(true)}>
                        <span className="material-symbols-outlined icon-size-l">
                            menu
                        </span>
                    </button>
                    : null}

                <Link className={style.logo} to={`/`}>{WEBSITE_NAME}</Link>

                <div className={style.controlView}>
                    {screen !== "search" ?
                        <Link to={"/search"}>
                            <span className="material-symbols-outlined icon-size-l">
                                search
                            </span>
                        </Link>
                        : null}

                    {getStorage("accountID") !== "" && (
                        <>
                            {screen !== "mybag" && screen !== "checkout" && screen !== "login" && screen !== "profile" ?
                                <Link className={style.myBagBtn} to={"/mybag"}>
                                    {getStorage("app_cart_items") && Number(getStorage("app_cart_items")) > 0 ? <span className={style.info}>{getStorage("app_cart_items")}</span> : null}
                                    <span className="material-symbols-outlined icon-size-l">
                                        local_mall
                                    </span>
                                </Link>
                                : null
                            }

                            {screen !== "account" && screen !== "login" && screen !== "profile" ?
                                <Link to={"/account"} className={style.myAccountBtn}>
                                    <span className="material-symbols-outlined icon-size-l">
                                        account_circle
                                    </span>
                                </Link>
                                : null}
                        </>
                    )}
                </div>
            </div>

            <div className={`${style.responsiveMenu} ${menuSlider ? style.showMenu : ''}`}>
                <div className={style.responsiveMenuBack} onClick={() => setMenuSlider(false)}></div>
                <div className={style.responsiveMenuContents}>
                    <div className={style.menuHeader}>
                        <p>Menu</p>
                        <button onClick={() => setMenuSlider(false)}>
                            <span className="material-symbols-outlined icon-size-sm">
                                close
                            </span>
                        </button>
                    </div>

                    <div className={style.menuContents}>

                        {getStorage("accountID") !== "" ? (
                            <section>
                                <p className={style.hint}>Account</p>
                                <Link to={"/account"}>
                                    <span className="material-symbols-outlined icon-size-s">
                                        account_circle
                                    </span>

                                    <p>My Profile</p>
                                </Link>
                                <Link to={"/myorders"}>
                                    <span className="material-symbols-outlined icon-size-s">
                                        package_2
                                    </span>

                                    <p>My Order</p>
                                </Link>
                                <Link to={"/mybag"}>
                                    <span className="material-symbols-outlined icon-size-s">
                                        local_mall
                                    </span>

                                    <p>My Bag</p>
                                </Link>
                            </section>
                        ) : (
                            <section>
                                <p className={style.hint}>Account</p>
                                <Link to={"/account"}>
                                    <span className="material-symbols-outlined icon-size-s">
                                        account_circle
                                    </span>

                                    <p>Log in / Sign up</p>
                                </Link>
                            </section>
                        )}

                        {categories.length > 0 ?
                            <section>
                                <p className={style.hint}>Categories</p>

                                {categories.map((data, index) => (
                                    <Link key={`category_${index}`}
                                        to={{
                                            pathname: "/search",
                                            search: `?q=${encodeURIComponent(data["item_id"])}&d=${encodeURIComponent(data["item_name"])}&linked=true`
                                        }}>
                                        <span className="material-symbols-outlined icon-size-sm">{data.item_icon}</span>
                                        <p>{data.item_name}</p>
                                    </Link>
                                ))}
                            </section>
                            : null}

                        <section>
                            <p className={style.hint}>Others</p>
                            <Button text="Need Help"
                                icon={"support_agent"}
                                rounded={true}
                                hoverEffect={true}
                                spaceTop={15}
                                action={{ onClick: () => window.open(getStorage("app_whatsapp_support_url"), "_blank") }} />
                        </section>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default View;